'use strict';

import {EwSiteApp} from "./ewsiteapp.js";
import {ewModel} from '../models/ewmodel.js';


export class ItemPreviewCtrl
{
	$scope;
	$mdDialog;
	$filter;
	item;
	viewOptions = {
		title: null,
		type: 'object',
		fields: []
	};
	
	constructor($mdDialog, $filter, item, options){
		this.$mdDialog = $mdDialog;
		this.$filter = $filter;
		this.item = item;
		this.setOptions(options);
	}
	
	setOptions(options){
		if(typeof(options.title) !== 'undefined'){
			this.viewOptions.title = options.title;
		}
		else{
			this.viewOptions.title = this.$filter('tr')('preview_title');
		}
		if(this.item instanceof ewModel){
			this.viewOptions.type = 'ewmodel';
		}
		if(typeof(options.fields) !== 'undefined'){
			this.viewOptions.fields = options.fields;
		}
	}
	
	getValue(field){
		if(this.viewOptions.type == 'ewmodel'){
			return this.item.getValue(field.name);
		}
		if(typeof(this.item[field.name]) !== 'undefined'){
			return this.item[field.name];
		}
		return '';
	}
	
	getTitle(field){
		if(typeof(field.title) !== 'undefined'){
			return field.title;
		}
		if(typeof(field.name) !== 'undefined'){
			return this.$filter('tr')(field.name + '_title');
		}
		return '';
	}
	
	close = function() {
		this.$mdDialog.cancel();
	};
	
}

EwSiteApp.controller('ItemPreviewCtrl', ["$mdDialog", "$filter", "item", "options", ItemPreviewCtrl]);
